var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.3 6a.7.7 0 0 1 .7-.7h14a.7.7 0 1 1 0 1.4H5a.7.7 0 0 1-.7-.7M4.3 12a.7.7 0 0 1 .7-.7h14a.7.7 0 1 1 0 1.4H5a.7.7 0 0 1-.7-.7M5 17.3a.7.7 0 1 0 0 1.4h14a.7.7 0 1 0 0-1.4z"
})));
export default SvgMenu;